import AdminAppBar from '../OpdAppBar/OpdAppBar'
import { Box } from '@mui/material'
import { Routes, Route } from 'react-router-dom'
import { useEffect, useContext, useRef, useState, useCallback } from 'react'
import useSearchQuery from '../Common/useSearchQuery'
import { Context } from '../UserContext'
import { useNavigate } from 'react-router-dom'
import { serverUrl } from '../constants'
import PageLoader from '../Common/PageLoader'
import axios from 'axios'
import Login from '../Login/Login'
import useNotify from '../useNotify'
import OpdAppBar from '../OpdAppBar/OpdAppBar'
import OpdListPage from '../OpdListPage/OpdListPage'

export default function OpdMainWindow() {
  const userContext = useContext(Context)
  const { notify } = useNotify()

  const query = useSearchQuery()
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)
  const dataFetchedRef = useRef(false)

  const proceedFurther = useCallback(() => {
    const lastLocation = localStorage.getItem('lastLocation')
    if (lastLocation) {
      localStorage.removeItem('lastLocation')
      navigate(lastLocation)
    }
  }, [navigate])

  const verifyUser = useCallback(
    async (token) => {
      try {
        const data = await axios
          .post(`${serverUrl}/verify-token`, {
            token,
          })
          .then((response) => response.data)
        return data
      } catch (e) {
        if (e?.response?.data?.message) {
          notify(e?.response?.data?.message)
        }
        return null
      }
    },
    [notify]
  )

  const validate = useCallback(async () => {
    setLoading(true)
    let existingToken = localStorage.getItem('token')
    const newToken = query.get('token')
    if (newToken) {
      localStorage.removeItem('token')
      let result = await verifyUser(newToken)
      if (result?.valid) {
        localStorage.setItem('token', newToken)
        userContext.setCurrUser(result.user)
        proceedFurther()
      } else {
        notify('Unauthorized User.')
      }
    } else if (existingToken) {
      let result = await verifyUser(existingToken)
      if (result?.valid) {
        userContext.setCurrUser(result.user)
        proceedFurther()
      } else {
        notify('Unauthorized User.')
      }
    }
    setLoading(false)
  }, [proceedFurther, verifyUser, query, userContext, notify])

  useEffect(() => {
    if (!dataFetchedRef.current) {
      if (!query.get('unauthorizedLogin')) {
        console.log('Verifying Token......')
        validate()
      } else {
        if (query.get('unauthorizedLogin')) {
          notify('Unauthorized User.')
        }
      }
      dataFetchedRef.current = true
    }
  }, [validate, query, notify])

  if (loading) {
    return <PageLoader />
  }

  if (!userContext.currUser || query.get('unauthorizedLogin')) {
    return <Login />
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <OpdAppBar />
      <Routes>
        <Route path="/" element={getMainView(<OpdListPage />)} />
      </Routes>
    </Box>
  )
}

function Sample({ Page }) {
  return <h1>{Page}</h1>
}

function getMainView(component) {
  return (
    <Box
      sx={{
        pt: '70px',
        width: '100%',
      }}
    >
      <div style={{ width: '100%' }}>{component}</div>
    </Box>
  )
}
